export interface CognitoConfig {
    enabled: boolean;
    userPoolId: string;
    clientId: string;
    domain: string;
    region: string;
    redirectUri: string;
    logoutUri: string;
}

export interface AuthenticationConf {
    loginUrl: string;
    cognito: CognitoConfig;
}

export const authenticationConf: AuthenticationConf = {
    loginUrl: '/auth/logout',
    cognito: {
        enabled: false,
        userPoolId: '',
        clientId: '',
        domain: '',
        region: 'eu-west-1',
        redirectUri: '',
        logoutUri: ''
    }
};
